import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./styles.css";
import { App } from "./App";

const el = document.getElementById("root");
if (!el) throw new Error("#root not found");
createRoot(el).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

// F-8: Service Worker 登録 (静的アセットの cache-first / HTML と /api は素通り)
// 方針は public/sw.js と docs/runbooks/spa-cache.md を参照。
// 緊急解除は /sw-unregister.html を開く。
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // 登録失敗は致命ではないので握りつぶす
    });
  });
}
